var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopilot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62564 5.248L8.47915 5.64448C7.52212 8.23115 5.48298 10.2702 2.89648 11.2271L2.5 11.3743L2.89648 11.5208C5.48315 12.4778 7.52215 14.5169 8.47915 17.1034L8.62564 17.4999L8.77277 17.1034C9.7298 14.5168 11.7689 12.4778 14.3554 11.5208L14.7519 11.3743L14.3554 11.2271C11.7688 10.2701 9.72977 8.23098 8.77277 5.64448L8.62564 5.248ZM14.752 2.5L14.6862 2.67773C14.2572 3.83788 13.3425 4.75257 12.1824 5.18223L12.0046 5.24799L12.1824 5.31374C13.3425 5.74278 14.2572 6.65749 14.6862 7.81758L14.752 7.99531L14.8177 7.81758C15.2468 6.65743 16.1615 5.74274 17.3222 5.31374L17.5 5.24799L17.3222 5.18223C16.1621 4.7532 15.2474 3.83848 14.8177 2.67773L14.752 2.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilot);
export default __webpack_public_path__ + "static/media/copilot.8056f36e1ebc48bfdde476a2797b399d.svg";
export { ForwardRef as ReactComponent };